export default __webpack_public_path__ + "static/media/power-icon.b0a8fb28.svg";